<template>
  <van-popup
    v-model:show="showDetail"
    round
    position="bottom"
    @closed="handlerClose()"
    @touchstart="onTouchStart"
    @touchmove="onTouchMove"
    @touchend="onTouchEnd"
    :close-on-popstate="true"
  >
    <loading :show-loading="showLoading" />
    <div class="card-detail" v-if="item">
      <div style="padding: 0px 16px">
        <div class="close-line">
          <div class="close-line-item"></div>
        </div>
        <h4 class="detail-title">{{ $t("confirm_your_purchase") }}</h4>
        <PostConfirmMetfoneService :data="item" />
        <hr class="card-line" />
        <div class="card-description" v-if="item.subFullDes">
          <div v-html="item.subFullDes"></div>
        </div>
        <div class="card-description" v-else>
          <div>{{ $t("Service package description is not available") }}</div>
        </div>
        <hr class="card-line" />
        <div>
          <div class="phone-number-title">
            {{ $t("phone_number") }}
            <van-popover
              v-model:show="showPopoverNunberPhoneInfo"
              theme="dark"
              placement="right-start"
            >
              <template #reference>
                <van-icon name="info-o" />
              </template>
              <template #default>
                <div style="padding: 6px 10px; max-width: 13em">
                  <p style="margin: 0px; font-size: 10px">
                    {{ $t("you_can_buy") }}
                  </p>
                </div>
              </template>
            </van-popover>
          </div>
          <div class="phone-number" style="padding: 2px 10px 2px 10px">
            <input
              ref="phoneNumberInput"
              @input="debounceInput"
              v-model="phoneNumber"
              type="text"
              inputmode="numeric"
              style="width: 85%; border: none"
              maxlength="19"
              minlength="7"
              @keydown="handleKeyDown2"
              @click="handleClick"
              @paste="handlePaste"
            />
            <!-- 
            <div class="btn-contact" @click="handleOpenContact">
              <img
                width="24"
                height="24"
                src="@/static/contacts32.png"
                class="object-contain"
                style="flex: none !important"
              />
            </div>
            -->
          </div>
          <div v-if="checkIsdn" class="input-errors">
            <div class="error-msg">{{ $t("phone_number_invalid") }}</div>
          </div>
          <div
            v-else
            class="input-errors"
            v-for="error of v$.phoneNumber.$errors"
            :key="error.$uid"
          >
            <div class="error-msg">{{ $t("phone_number_invalid") }}</div>
          </div>
        </div>
      </div>
 
      <div
        style="
          margin-top: 15px;
          padding: 16px 16px;
          box-shadow:
            0 3px 6px rgba(0, 0, 0, 0.6),
            0 3px 6px rgba(0, 0, 0, 0.2);
        "
      >
   <!-- 
        <div
          class="credit-card"
          v-if="defaultAcc && defaultAcc.accountName != ''"
        > 
          <div style="">
            <div class="icon-aba-pay">
              <img class="credit-card-image" src="@/static/abapay.svg" />
              <span
                class="credit-card-title fw-bold"
                :style="{ fontSize: '15px' }"
                >ABA PAY</span
              >
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                padding: 16px 0px;
              "
            >
              <div>
                <div
                  class="saving-account savingname-container fw-bold limited-text"
                >
                  {{ defaultAcc.accountName }}
                </div>
                <span class="credit-card-phone">
                  {{ formatPhoneNumber(defaultAcc.accountNumber) }} |
                  {{ defaultAcc.currency }}
                </span>
              </div>

              <div
                :class="{ disabled: showLoading }"
                class="saving-change"
                @click="((showLoading = true), debouncedHandleClick(false))"
              >
                <div
                  style="
                    display: flex;
                    height: 22px;
                    justify-items: center;
                    justify-content: center;
                    gap: 4px;
                    align-items: center;
                  "
                >
                  <div :style="{ color: color_primary() }">
                    {{ $t("fuction_change") }}
                  </div>
                  <div style="width: 16px; height: 16px">
                    <img
                      class="saving-change-icon"
                      src="@/static/icon-change-pay.svg"
                      alt="icon change"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
 
        </div>
-->

        <div class="btn-bottom">
          <van-button
            :disabled="showLoading || !isPhoneValid"
            @click="
              ((showLoading = true),
              debouncedHandleClick())
            "
            class="btn-buy"
            type="danger"
            :color="color_primary()"
          >
            <p class="btn-buy-content" v-if="item.price">
              {{ $t("buy") }} ${{ item.price.toFixed(2) }}
            </p>
          </van-button>

          <!--        <div v-if="isMetfoneNumber"  class="btn-auto-renew">-->
          <!--          <div style="width: 50px;">-->
          <!--            <van-switch v-model="switchChecked" size="15" active-color="#0D993D">-->
          <!--            </van-switch>-->
          <!--          </div>-->
          <!--          <div>-->
          <!--            <span class="btn-auto-renew-title"> {{ $t("auto_renew") }} </span>-->
          <!--            <div class="btn-auto-renew-description">-->
          <!--              {{ $t("if_auto_renew") }}-->
          <!--            </div>-->
          <!--          </div>-->
          <!--        </div>-->
          <!--        -->
        </div>
      </div>
    </div>
    <metfone-notify
      v-model:is-show.sync="checkMobileMetfoneNumber"
    ></metfone-notify>
  </van-popup>
</template>

<script>
import { Switch, Popup, Button, Field, NumberKeyboard } from "vant";
import PostConfirmMetfoneService from "@/components/post-confirm-metfone-service";
import { mapState } from "vuex";
import MetfoneNotify from "@/components/metfone-notify";
import { useVuelidate } from "@vuelidate/core";
import { required, minLength, maxLength, helpers } from "@vuelidate/validators";
import _, { random } from "lodash";
import Loading from "@/components/loading";
import { CONSTANTS } from "@/helpers/constants";
import { encrypt, sign, keyToPem } from "anhdev99.rsa";
import { getTransactionHash } from "@/ultis/hashPayment";
import {
  formatDateToDDMMYYYYHHMMSS,
  formatDateToEN_US,
} from "@/ultis/dateFormat";
import { ref } from "vue";
import { AsYouType, parsePhoneNumber } from "libphonenumber-js";
import { mask } from "vue-the-mask";
import getErrorMessage from "@/helpers/error-server";
import {
  claimGetStatusOwner,
  releaseGetStatusOwner,
  runGetStatusOnce,
} from "@/ultis/getStatusGuard";

export default {
  name: "ConfirmPurchase",
  components: {
    Loading,
    MetfoneNotify,
    [Switch.name]: Switch,
    [Popup.name]: Popup,
    [Button.name]: Button,
    [Field.name]: Field,
    [NumberKeyboard.name]: NumberKeyboard,
    PostConfirmMetfoneService,
  },
  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
    item: {
      type: Object,
      required: false,
    },
  },
  directives: { mask },
  setup() {
    const show = ref(false);
    const phoneNumberInput = ref(null);
    const phoneNumberInputtest = ref(null);
    // const phoneNumber = ref('');
    return { v$: useVuelidate(), show, phoneNumberInput, phoneNumberInputtest };
  },
  validations() {
    return {
      phoneNumber: {
        required,
        // regex: alphaNumAndDotValidator,
        minLength: minLength(8),
        maxLength: maxLength(19),
      }, // Matches this.firstName
    };
  },
  data() {
    return {
      showPopoverNunberPhoneInfo: false,
      showDetail: false,
      switchChecked: false,
      payment: {
        amount: "",
        account: "",
        currency: "USD",
        additionalKey: {
          //autoRenew: false,
          //msisdn: "",
          remark: "",
        },
      },
      defaultAcc: {
        accountName: "",
        accountNumber: "",
        currency: "",
      },
      loading: false,
      checkMobileMetfoneNumber: false,
      isMetfoneNumber: true,
      phoneNumber: "",
      showLoading: false,
      description: "",
      dataMessage:
        "<data>    <merchantAccount>EMONEY</merchantAccount>    <isdn>855972152686</isdn>    <packageCode>DATA_1</packageCode>    <serviceType>EXCHANGE_DATA_OSJA</serviceType>    <time>02/08/2023 16:28:11</time>    <requestId>230801000000000</requestId>    <account>855886391183</account></data>",
      transactionId: "",
      resultSuccess: null,
      isdn: null,
      checkIsdn: false,
      startY: null,
      maxLength: 25,
      consumerId: null,
      cursorPositionBefore: 0,
      asYouTypeCountry: "KH",
      isDeleted: false,
      oldPhone: "",
      spacing: 0,
      firstLoadItem: false,
      isActionScheduled: false,
      isPaste: false,
      currentPositionInsert: 0,
      lengthTextInsert: 0,
      checkIsPaste: false,
      checkIsDeleted: false,
      isMaxPaste: false,
      hashPayment: null,

      preBuyPackageInfo: null,
      remarkInfo: null,
      dataGetStatus: null
    };
  },
  async created() {
    this.loadFirstPhoneNumber();
    await this.getDefaultAcc();
  },
  computed: {
    ...mapState("userStore", [
      "profile",
      "changeProfile",
      "phoneNumberIsMetfone",
      "defaultParam",
    ]),
    getPrice() {
      return this.item ? this.item.price : "0";
    },
    truncatedData() {
      if (this.defaultAcc && this.defaultAcc.accountName) {
        let longData = this.defaultAcc.accountName;
        return longData.length > this.maxLength
          ? longData.slice(0, this.maxLength) + "..."
          : longData;
      }
      return "";
      // Truncate the data if it exceeds the maximum length
    },
    isPhoneValid() {
      if (!this.phoneNumber) return false;
      const digits = this.formatSpacingPhoneNumber(this.phoneNumber);
      return this.regexMetfone(digits);
    },
  },
  watch: {
    phoneNumber(newValue, oldValue) {
      if (this.isPaste) {
        this.isPaste = false;
        // this.phoneNumber = this.formatPhoneNumberTwo(val);
        const character = this.phoneNumber.slice(-1);
        const parsedCharacter = this.parseDigit(character);
        this.phoneNumber =
          parsedCharacter === "+"
            ? parsedCharacter
            : this.phoneNumber.substring(0, this.phoneNumber.length - 1) +
              parsedCharacter;

        // const {text, invalid} = this.formatPhoneNumberTwo(this.phoneNumber);

        const text = this.formatPhoneNumberTwo(this.phoneNumber.trim());
        this.phoneNumber = text;

        let checkEmpty =
          oldValue != null
            ? oldValue[this.currentPositionInsert] === " "
            : false;
        var lastIndex1 =
          oldValue != null ? (oldValue.match(/ /g) || []).length : 0;
        var lastIndex2 = text != null ? (text.match(/ /g) || []).length : 0;
        var temp = this.phoneNumber.substring(
          this.currentPositionInsert,
          this.currentPositionInsert +
            this.lengthTextInsert +
            (checkEmpty ? (lastIndex2 > lastIndex1 ? lastIndex2 : 0) : 0),
        );
        var lastIndex = (temp.match(/ /g) || []).length;

        this.$nextTick().then(() => {
          // console.log("this.currentPositionInsert + this.lengthTextInsert +lastIndex",this.currentPositionInsert ,this.lengthTextInsert ,lastIndex)
          this.phoneNumberInput.selectionStart =
            this.currentPositionInsert +
            this.lengthTextInsert +
            lastIndex +
            (this.isMaxPaste ? 1 : 0);
          this.phoneNumberInput.selectionEnd =
            this.currentPositionInsert +
            this.lengthTextInsert +
            lastIndex +
            (this.isMaxPaste ? 1 : 0);
          this.isMaxPaste = false;
        });
        let rep = this.formatSpacingPhoneNumber(this.phoneNumber);
        var formatPhoneNumberCheck = this.regexMetfone(rep);
        if (!formatPhoneNumberCheck) {
          this.checkIsdn = true;
          return;
        } else {
          this.checkIsdn = false;
        }
      }
    },
    checkMobileMetfoneNumber(val) {
      if (val == false) {
        this.phoneNumber = "";
      }
      this.checkIsdn = false;
    },
    async isShow(val) {
      if (val) await this.getDefaultAcc();

      this.showDetail = val;
    },
    item() {
      this.loadFirstPhoneNumber();
    },
  },
  async mounted() {
    this.loadFirstPhoneNumber();
    this.showDetail = this.isShow;

    // Chỉ instance mới nhất xử lý getStatus (tránh instance cũ chưa gỡ handler).
    claimGetStatusOwner(this);
    this.$bridge.registerHandler("getStatus", async (data) => {
      await runGetStatusOnce(this, data, async (payload) => {
        this.dataGetStatus = payload;
        await this.handleGetStatus(payload);
      });
    });
  },
  beforeUnmount() {
    releaseGetStatusOwner(this);
  },
  methods: {
    async handleGetStatus(data){
      console.log("Data from native getStatus: ", data);
      this.showLoading = true;
      await this.timeout(1000);
      const currentDate = new Date(); 
      if (data) {
        this.transactionId = data.transactionId;      
        const params = this.stateAsObject(this.defaultParam); 
        params.orderRef = data.orderRef;
        params.transactionId = data.transactionId;
        params.transactionDate = data.transactionDate;
        params.debitAmount = data.debitAmount;
        params.debitCcy = data.debitCcy;
        params.remark = this.remarkInfo.remark
        params.secretKey = data.secretKey
        await this.$store
          .dispatch("metfoneStore/transactionCallback", params)
          .then(async (res) => {
            if (res) {
              let result = res.data;
              if (result && result.errorCode == 0) {
                this.resultSuccess = {
                  subcribeId: this.transactionId,
                  subcribeDate: formatDateToEN_US(currentDate, this.isKHM()),
                  paidFrom: this.phoneNumber,
                  price: this.getPrice,
                  unit: this.item.unit,
                  content: this.item.subFullDes ? this.item.subFullDes : "",
                  title: this.item.serviceName,
                };
                this.$router.replace({
                  path: "payment-success",
                  query: this.resultSuccess,
                });
              } else {
                this.$router.replace({
                  path: "payment-faild",
                  query: {
                    subcribeId: this.transactionId,
                  },
                });
              }
            }
          });
        this.showLoading = false;
      }
    },

    async prePayment() {
      let mes = `<data>
        <merchantAccount>WING</merchantAccount>
        <partnerAccount>${this.profile.id}</partnerAccount>
        <paidIsdn>${this.formatSpacingPhoneNumber(this.phoneNumber)}</paidIsdn>
        <packageCode>${this.item.serviceCode}</packageCode>
      </data>`;
      console.log("prePayment Mes: ", mes); 
      const params = this.stateAsObject(this.defaultParam);
      const privateKeyPem = keyToPem(CONSTANTS.PRIVATE_KEY, "PRIVATE KEY");
      const publicKeyPem = keyToPem(CONSTANTS.PUBLIC_KEY, "PUBLIC KEY");
      params.signature = sign(mes, privateKeyPem);
      params.encrypt = encrypt(mes, publicKeyPem);

      
      const res = await this.$store.dispatch("metfoneStore/prePayment", params)
      if (res) {
        let result = res.data;
        if (result && result.errorCode == 0) { 
          this.preBuyPackageInfo = result.preBuyPackageInfo;
          console.log("preBuyPackageInfo: ", this.preBuyPackageInfo);
          return true;
        } else {
          if(result.errorCode == 5 || result.errorCode == "5"){
           this.checkIsdn = true; 
          }else{
            this.$store.dispatch("notifyStore/addNotify", {
              code: 1,
              message:result.message,
            });
          }
          return false;
        }
      }
      return false;
    },

    async getRemark() {
      let mes = `<data>
        <merchantAccount>WING</merchantAccount>
        <transactionType>BUY_PACKAGE</transactionType>
        <partnerAccount>${this.profile.id}</partnerAccount>       
        <orderCode>${this.preBuyPackageInfo.orderCode}</orderCode>
      </data>`;
      console.log("getRemark Mes: ", mes); 
      const params = this.stateAsObject(this.defaultParam);
      const privateKeyPem = keyToPem(CONSTANTS.PRIVATE_KEY, "PRIVATE KEY");
      const publicKeyPem = keyToPem(CONSTANTS.PUBLIC_KEY, "PUBLIC KEY");
      params.signature = sign(mes, privateKeyPem);
      params.encrypt = encrypt(mes, publicKeyPem);
      const res = await this.$store.dispatch("metfoneStore/getRemark", params)
      if (res) {
        let result = res.data;
        if (result && result.errorCode == 0) { 
          this.remarkInfo = result.remarkInfo;
          console.log("remarkInfo: ", this.remarkInfo);
          return true;
        } else {
          this.$store.dispatch("notifyStore/addNotify", {
            code: 1,
            message: result.message,
          });
          return false;
        }
      }
      return false;
    },

    async handleBuy() {
      console.log("Package info", this.item); 
      //this.showLoading = false;
      this.checkIsdn = false; 
      const isFormCorrect = await this.v$.$validate(); 
      if (!isFormCorrect) return; 

      let prePaymentRes = await this.prePayment();
      if (!prePaymentRes) {
        this.showLoading = false;
        return;
      }  
      let getRemarkRes = await this.getRemark();
      if (!getRemarkRes) {
        this.showLoading = false;
        return;
      }  
      this.resetPaymentPayload();  
      this.payment.amount = Number(this.remarkInfo.amount || 0).toFixed(2);
      this.payment.currency = "USD";  
      this.payment.useDefault = true;  

      this.payment.account = this.remarkInfo.orderCode;
      this.payment.appId = this.profile.appId;

      this.payment.additionalKey.hash = this.remarkInfo.hash;
      this.payment.secretApiKey = CONSTANTS.SECRET_API_KEY;
 
      // Add remark
      let remarkText = this.formatSpacingPhoneNumber(this.phoneNumber);
      if (remarkText.startsWith("855")) {
        remarkText = remarkText.slice(3);
      }
      if (remarkText.startsWith("0")) {
        remarkText = remarkText.slice(1);
      } 
      remarkText = `DataOsja : ${remarkText}`;
      this.payment.additionalKey.remark = remarkText;
  
      if (process.env.VUE_APP_BYPASS_NATIVE_API === "false") {

        console.log("[==> doPayment]", this.payment);

        this.$bridge.callHandler("doPayment", this.payment)
        .then((data) => {
          console.log("doPayment then ", data)
        })
        .finally(() => {
          console.log("doPayment finally")
        }); 
          
      } 
      else {
        console.log("[==> FAKE doPayment]", this.payment);

        const currentDate = new Date();
        this.resultSuccess = {
          subcribeId: this.transactionId,
          subcribeDate: formatDateToEN_US(currentDate, this.isKHM()),
          paidFrom: this.phoneNumber,
          price: this.getPrice,
          unit: this.item.unit,
          content: this.item.subFullDes ? this.item.subFullDes : "",
          title: this.item.serviceName,
        };
        this.$router.replace({
          path: "payment-success",
          query: this.resultSuccess,
        });

          /*
          await this.handleGetStatus({
            transactionId:"tran_" + new Date().getTime(),
          });
        */
      }
      
      setTimeout(() => {
        this.showLoading = false;
      }, 500);
    },
  

 
    //Chưa dùng: đã tắt ở UI
    handleOpenContact() {
      console.log("Open contact picker"); 
      if (process.env.VUE_APP_BYPASS_NATIVE_API === "false") {
        this.$bridge.callHandler("getContact").then((data) => {
          console.log("Contact data:", data);
          if (data && data.phone) {
            this.phoneNumber = this.formatPhoneNumberTwo(
              data.phone.replace(/\D/g, ""),
            );
            // Validate phone number after getting from contact
            let rep = this.formatSpacingPhoneNumber(this.phoneNumber);
            let formatPhoneNumberCheck = this.regexMetfone(rep);
            this.checkIsdn = !formatPhoneNumberCheck;
          }
        });
      } else {
        const data = {
          name: "Test Contact" + Math.floor(1000 + Math.random() * 9000),
          phone: "+855" + Math.floor(10000000 + Math.random() * 90000000),
        };
        console.log("Dev mode: Contact picker not available", data);
        this.phoneNumber = this.formatPhoneNumberTwo(
          data.phone.replace(/\D/g, ""),
        );
        // Validate phone number after getting from contact
        let rep = this.formatSpacingPhoneNumber(this.phoneNumber);
        let formatPhoneNumberCheck = this.regexMetfone(rep);
        this.checkIsdn = !formatPhoneNumberCheck;
      } 
    },

    async handleGenTransId() {
      const currentDate = new Date();
      const currentDateSTR = formatDateToDDMMYYYYHHMMSS(currentDate);
      let account = "";
      if (this.profile) {
        account = this.profile.appId;
      } else {
        console.error("Profile not found.");
        return;
      }

      let mes = `<data>
        <merchantAccount>MINI_APP</merchantAccount>    
          <isdn>${this.formatSpacingPhoneNumber(this.phoneNumber)}</isdn>    
          <packageCode>${this.item.subCode}</packageCode>    
          <serviceType>EXCHANGE_DATA_OSJA</serviceType>    
          <time>${currentDateSTR}</time>    
          <requestId></requestId>    
          <account>${account}</account>
        </data>`;
 
      console.log("Mes: ", mes);
      const params = this.stateAsObject(this.defaultParam);
      const privateKeyPem = keyToPem(CONSTANTS.PRIVATE_KEY, "PRIVATE KEY");
      const publicKeyPem = keyToPem(CONSTANTS.PUBLIC_KEY, "PUBLIC KEY");
      params.signature = sign(mes, privateKeyPem);
      params.encrypt = encrypt(mes, publicKeyPem);
      params.msisdn =  this.formatSpacingPhoneNumber(this.phoneNumber);

      console.log("Params Gen PRIVATE_KEY: ", CONSTANTS.PRIVATE_KEY);
      console.log("Params Gen PUBLIC_KEY: ", CONSTANTS.PUBLIC_KEY);

      console.log("Generate Params: ", params);
       
      await this.$store
        .dispatch("metfoneStore/genRequestId", params)
        .then(async (res) => {
          if (res) {
            let result = res.data;
            if (result && result.errorCode == 0) {
              this.consumerId = result.requestId;
              return;
            } else { 
              console.log("Error gen requestId: ", result);
              this.consumerId = random(100000000000000, 999999999999999).toString();
              return;
              /*
              this.$store.dispatch("notifyStore/addNotify", {
                code: 1,
                message: getErrorMessage(result.errorCode),
              });
              */
            }
          }
          this.consumerId = null;
        });
    },

    color_primary() {
      return CONSTANTS.color_primary;
    },
    formatPhoneNumber(phoneNumber) {
      phoneNumber = phoneNumber.replace(/\D/g, "");

      if (phoneNumber.length >= 7) {
        return phoneNumber.replace(/(\d{3})(\d{3})(\d{3,4})/, "$1 $2 $3");
      }

      return phoneNumber;
    },
    formatPhoneNumberTwo(phoneNumber) {
      let cleanedNumber = phoneNumber;
      if (cleanedNumber.length >= 3) {
        cleanedNumber = cleanedNumber.replace(/\s+/g, ""); //Remove illegal characters
        if (cleanedNumber.length > 3)
          cleanedNumber = cleanedNumber.replace(/.{3}/, "$& "); //Add hyphen at pos.4
        if (cleanedNumber.length > 7)
          cleanedNumber = cleanedNumber.replace(/.{7}/, "$& ");
        if (cleanedNumber.length >= 11 && cleanedNumber.length <= 12) {
          cleanedNumber = cleanedNumber.replace(/.{13}/, "$& ");
        } else {
          cleanedNumber = cleanedNumber.replace(/.{11}/, "$& ");
        }
        if (cleanedNumber.length >= 15 && cleanedNumber.length <= 16) {
          cleanedNumber = cleanedNumber.replace(/.{17}/, "$& ");
        } else {
          cleanedNumber = cleanedNumber.replace(/.{15}/, "$& ");
        }
        return cleanedNumber;
      } else {
        return phoneNumber;
      }
    },
   
    
    isKHM() {
      const currentLanguage = this.$i18n.locale;
      if (currentLanguage == "kh") return true;
      return false;
    },
    onTouchStart(event) {
      this.startY = event.touches[0].clientY;
    },

    onTouchMove(event) {
      if (this.startY === null) return;

      const currentY = event.touches[0].clientY;
      const deltaY = currentY - this.startY;

      // Threshold to decide if it's a swipe down
      if (deltaY > 50) {
        this.$emit("update:isShow", false);
        this.startY = null;
      }
    },
    onTouchEnd() {
      this.startY = null;
    },

    stateAsObject(value) {
      return JSON.parse(JSON.stringify(value));
    },
    async timeout(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    regexMetfone(phone) {
      if ((phone && phone.length < 8) || phone.length > 16) return false;
      let regex =
        /^(?:00855|855|0)?(31|60|66|67|68|71|88|90|97|236|246|256|266|326|336|346|356|366|426|436|446|526|536|546|556|626|636|646|656|726|736|746|756)\d+$/;
      // let regex = /(00855|855|0|)|(31|60|66|67|68|71|88|90|97|236|246|256|266|326|336|346|356|366|426|436|446|526|536|546|556|626|636|646|656|726|736|746|756)\d{6,7}$/
      // let regex = /^(?:\+855|0)?([689][0-9]|7[0-9]|5[0-4]|3[0-9]|2[0-9]|1[0-9]|0[2-9])\d{6,8}$/;
      let result = regex.test(phone);
      return result;
    },
    formatSpacingPhoneNumber(phone) {
      return phone.replace(/ /g, "");
    },
    handleClick() {
      // this.phoneNumberInputtest.value = Date.now().toString()
      // this.phoneNumber = this.phoneNumber+ "k";
      // const character = this.phoneNumber.slice(-1);
      // const parsedCharacter = this.parseDigit(character);
      // let isCheckPhone = this.oldPhone.length >= this.phoneNumber.length;
      // // console.log("isCheckPhone", isCheckPhone, this.oldPhone, this.phoneNumber)
      // this.phoneNumber =
      //     parsedCharacter === '+'
      //         ? parsedCharacter
      //         : this.phoneNumber.substring(0, this.phoneNumber.length - 1) + parsedCharacter;
      //
      // this.phoneNumber = this.formatPhoneNumberTwo(this.phoneNumber)
    },
    handleKeyDown2(event) {
      if (event.key === "Backspace" || event.keyCode === 8) {
        const caretPosition = event.target.selectionStart;
        this.cursorPositionBefore = caretPosition;
        const caretPositionEnd = event.target.selectionEnd;
        this.checkIsDeleted = false;
        if (
          caretPositionEnd.length == this.phoneNumber.length &&
          caretPosition.length < caretPositionEnd.length
        ) {
          this.checkIsDeleted = true;
        }
        this.isDeleted = true;
        // let check = this.phoneNumber[caretPosition] === " ";
        // if(check){
        //   this.checkIsDeleted = false;
        // }
        if (caretPosition > 0 && this.phoneNumber[caretPosition - 1] === " ") {
          // this.$nextTick(() => {
          //   this.phoneNumberInput.selectionStart = caretPosition + (check? -1: 0);
          //   this.phoneNumberInput.selectionEnd =caretPosition  + (check? -1: 0);
          // });
        }
      } else {
        this.isDeleted = false;
      }
    },
    handleKeyDown(event) {
      if (this.phoneNumberInput.selectionStart == 0) {
        return;
      }
      if (event.key === "Backspace" || event.keyCode === 8) {
        // console.log("event.target.selectionStart", event.target.selectionStart)
        const caretPosition = event.target.selectionStart;
        const caretPositionEnd = event.target.selectionEnd;
        this.checkIsDeleted = true;
        if (
          caretPositionEnd.length == this.phoneNumber.length &&
          caretPosition.length < caretPositionEnd.length
        ) {
          this.checkIsDeleted = true;
        }

        if (caretPosition > 0 && this.phoneNumber[caretPosition - 1] === " ") {
          var text =
            this.phoneNumber.slice(0, caretPosition - 2) +
            this.phoneNumber.slice(caretPosition);
          this.isDeleted = true;

          const temp = this.phoneNumber.substring(
            this.phoneNumberInput.selectionStart,
          );
          // this.cursorPositionBefore = event.target.selectionStart;
          const spaceCount = temp.split(" ").length - 1;
          // this.phoneNumberInput.selectionStart = this.phoneNumberInput.selectionStart - 2;
          this.phoneNumber = this.formatPhoneNumberTwo(text);
          // console.log("event.target.selectionStart 1", event.target.selectionStart)

          // console.log("this.phoneNumber.length - event.target.selectionStart", this.phoneNumber.length, event.target.selectionStart)
          event.preventDefault();
          this.$nextTick(() => {
            this.phoneNumberInput.selectionStart = caretPosition;
            this.phoneNumberInput.selectionEnd = caretPosition;
          });
          // if(this.phoneNumber.length <= 3)
          //   setTimeout(() =>{  this.phoneNumberInput.setSelectionRange(event.target.selectionStart , event.target.selectionStart)}, 50)
          // else{
          //   setTimeout(() =>{  this.phoneNumberInput.setSelectionRange(event.target.selectionStart - (this.phoneNumber.length - event.target.selectionStart) , event.target.selectionStart -  (this.phoneNumber.length - event.target.selectionStart))}, 50)
          // }
        } else {
          // console.log("event.target.selectionStart", event.target.selectionStart)
          this.isDeleted = true;
          if (this.phoneNumber.indexOf(" ") !== -1 && this.isDeleted) {
            const temp = this.phoneNumber.substring(
              this.phoneNumberInput.selectionStart,
            );
            const spaceCount = temp.split(" ").length - 1;
            // this.cursorPositionBefore =this.phoneNumberInput.selectionStart - 1;
            let text =
              this.phoneNumber.slice(0, caretPosition) +
              this.phoneNumber.slice(caretPosition);
            this.phoneNumber = this.formatPhoneNumberTwo(text);
            // console.log("event.target.selectionStart 2", text)
            // setTimeout(() => {this.phoneNumberInput.setSelectionRange(event.target.selectionStart , event.target.selectionStart )}, 0)
            // event.preventDefault();
            // event.preventDefault();
            setTimeout(
              () =>
                this.phoneNumberInput.setSelectionRange(
                  event.target.selectionStart +
                    (spaceCount > 1
                      ? spaceCount - 1
                      : spaceCount == 0
                        ? 0
                        : spaceCount),
                  event.target.selectionStart +
                    (spaceCount > 1
                      ? spaceCount - 1
                      : spaceCount == 0
                        ? 0
                        : spaceCount),
                ),
              100,
            );
          } else {
            this.isDeleted = false;
          }
        }
      } else {
        this.isDeleted = false;
      }
    },
    parseDigit(character) {
      return /\d/.test(character) ? character : "";
    },
    formatPhoneNumber1(value) {
      let text;
      let template;
      let isValid;
      let nationNumber;
      try {
        const phoneNumber = parsePhoneNumber(value, this.asYouTypeCountry);
        const asYouType = new AsYouType(this.asYouTypeCountry);
        text = asYouType.input(value);
        template = asYouType.getTemplate();
        isValid = asYouType.isValid();

        text = phoneNumber.formatNational();
      } catch (error) {
        if (error.message.indexOf("Unknown country") === 0) {
          text = value;
          template = value.replace(/./g, "x");
        } else {
          throw error;
        }
      }
      return { text, template, isValid, nationNumber };
    },
    extractNumbers(text) {
      // Use regex to match numbers in the input string
      const numberRegex = /\d+/g;

      // Match all numbers in the input string
      // const matches = text.match(numberRegex);

      // Update the extractedNumbers data property with the matched numbers as a string
      const matches = (text.match(numberRegex) || []).join("");
      return matches;
    },
    handlePaste(event) {
      event.preventDefault();

      const pastedText = (event.clipboardData || window.clipboardData).getData(
        "text",
      );
      const extractNumbers = this.extractNumbers(pastedText);
      const textBeforeSelection = this.phoneNumberInput.selectionStart;
      const textAfterSelection = this.phoneNumberInput.selectionEnd;
      // Insert the pasted text at the specified position
      if (this.phoneNumber == null) this.phoneNumber = "";
      const modifiedText =
        this.phoneNumber.slice(0, textBeforeSelection) +
        extractNumbers +
        this.phoneNumber.slice(textAfterSelection);
      // console.log("modifiedText.length",this.formatPhoneNumberTwo(modifiedText).length, modifiedText)
      this.isMaxPaste = false;
      let phoneNumberFormat = this.formatPhoneNumberTwo(modifiedText).substring(
        0,
        19,
      );
      if (this.formatPhoneNumberTwo(modifiedText).length >= 19) {
        this.phoneNumber = this.formatSpacingPhoneNumber(phoneNumberFormat);

        this.isMaxPaste = textBeforeSelection === 0;
      } else {
        // console.log("phoneNumberFormat", phoneNumberFormat.length)
        this.isMaxPaste =
          phoneNumberFormat.length == 14 || phoneNumberFormat.length == 18;
        this.phoneNumber = this.formatSpacingPhoneNumber(
          this.formatPhoneNumberTwo(modifiedText),
        );
      }

      this.checkIsPaste = true;
      this.isPaste = true;
      this.currentPositionInsert = textBeforeSelection;
      this.lengthTextInsert = extractNumbers.length;
    },
    debounceInput: _.debounce(function (e) {
      const caretPosition = this.phoneNumberInput.selectionStart;
      // const caretPosition = e.target.selectionStart;
      var phone = this.regexMetfone(e.target.value);
      if (phone) {
        return;
      }
      // console.log("1231")
      //
      // if(this.isDeleted)
      //   return;
      const character = this.phoneNumber.slice(-1);
      const parsedCharacter = this.parseDigit(character);
      let isCheckPhone = this.oldPhone.length >= this.phoneNumber.length;
      // console.log("isCheckPhone", isCheckPhone, this.oldPhone, this.phoneNumber)
      this.phoneNumber =
        parsedCharacter === "+"
          ? parsedCharacter
          : this.phoneNumber.substring(0, this.phoneNumber.length - 1) +
            parsedCharacter;

      // const {text, invalid} = this.formatPhoneNumberTwo(this.phoneNumber);

      const text = this.formatPhoneNumberTwo(this.phoneNumber.trim());
      // console.log("textt: asdf sadf", text, this.isDeleted)
      this.cursorPositionBefore = this.phoneNumberInput.selectionStart;

      this.phoneNumber = text;

      if (this.phoneNumber.indexOf(" ") !== -1 && this.isDeleted == false) {
        // var temp = this.phoneNumber.substring(this.cursorPositionBefore - 1);
        // var lastIndex  = this.phoneNumber.lastIndexOf(" ");
        // var spaceCount =temp.split(" ").length - 1;

        var spaceTwo = this.phoneNumber.split(" ").length >= 2;
        var isOldSpace = e.target.value.length >= this.oldPhone.length;
        var isChange = false;
        // console.log("IsOld", isOldSpace)
        // if(this.spacing != ( this.phoneNumber.match(/ /g) || []).length){
        //   console.log(this.phoneNumber.split(" ").length)
        //   this.spacing = ( this.phoneNumber.match(/ /g) || []).length
        //   isChange = true;
        // }else{
        //   // this.spacing =0
        //   isChange = false;
        // }
      }
      if (this.spacing != (this.phoneNumber.match(/ /g) || []).length) {
        console.log(this.phoneNumber.split(" ").length);
        this.spacing = (this.phoneNumber.match(/ /g) || []).length;
        isChange = true;
      } else {
        // this.spacing =0
        isChange = false;
      }
      var temp = this.phoneNumber.substring(caretPosition);
      var lastIndex = (temp.match(/ /g) || []).length;
      var pointerNearEmpty = this.phoneNumber[caretPosition - 1] === " ";
      var lastNumber = this.phoneNumber[caretPosition - 1] === " ";
      // console.log("Update",lastNumber)

      let check1 = this.phoneNumber.length === e.target.selectionStart;

      // if(this.phoneNumber.length > 18)
      //   setTimeout(() => this.phoneNumberInput.setSelectionRange(this.cursorPositionBefore , this.cursorPositionBefore), 10)
      // else
      //     // setTimeout(() =>{  this.phoneNumberInput.setSelectionRange(this.cursorPositionBefore ,this.cursorPositionBefore)}, 50)
      //   setTimeout(() => this.phoneNumberInput.setSelectionRange(this.cursorPositionBefore + (spaceCount > 0 ? lastIndex !== -1 && lastIndex > this.cursorPositionBefore ? 0 : isCheckPhone ? spaceCount - 1 : spaceTwo ? spaceCount :  -1: 0 ), this.cursorPositionBefore +  (spaceCount > 0 ? lastIndex !== -1 && lastIndex > this.cursorPositionBefore ? 0 : isCheckPhone ? spaceCount - 1 :spaceTwo ? spaceCount : -1: 0 )), 50)
      // //
      this.isActionScheduled = true;
      this.$nextTick().then(() => {
        if (this.isActionScheduled) {
          // this.phoneNumberInput.selectionStart =caretPosition  + (spaceCount > 0 ? lastIndex !== -1 && lastIndex > caretPosition ? 0 : isCheckPhone ? spaceCount - 1 : isChange && spaceTwo ? 0: isChange ? spaceCount : 0:  1 );
          // this.phoneNumberInput.selectionEnd =caretPosition + (spaceCount > 0 ? lastIndex !== -1 && lastIndex > caretPosition ? 0 : isCheckPhone ? spaceCount - 1 : isChange && spaceTwo ? 0:  isChange ? spaceCount : 0:  1 );
          // console.log(' this.spacing', this.spacing, e.target.selectionStart, lastIndex, isChange, lastNumber, this.cursorPositionBefore, this.firstLoadItem, check1, this.phoneNumber.length == e.target.selectionStart, "test", this.firstLoadItem || !check1, this.checkIsPaste)
          // console.log(" this.checkIsDeleted",  this.firstLoadItem || !check1 || this.checkIsPaste || this.checkIsDeleted)
          // if(!this.checkIsDeleted){
          //   this.checkIsPaste = false
          // }
          let checkPhone1417 =
            this.checkIsPaste &&
            (this.phoneNumber.length == 12 || this.phoneNumber.length == 16);
          // console.log("checkPhone1417: ", checkPhone1417, this.phoneNumber.length)
          this.phoneNumberInput.selectionStart = this.isDeleted
            ? isChange
              ? this.firstLoadItem ||
                !check1 ||
                this.checkIsPaste ||
                this.checkIsDeleted
                ? checkPhone1417
                  ? caretPosition - 1
                  : caretPosition
                : caretPosition - 1
              : caretPosition
            : caretPosition +
              (!isChange || lastIndex != 0 ? (pointerNearEmpty ? 1 : 0) : 1);
          this.phoneNumberInput.selectionEnd = this.isDeleted
            ? isChange
              ? this.firstLoadItem ||
                !check1 ||
                this.checkIsPaste ||
                this.checkIsDeleted
                ? checkPhone1417
                  ? caretPosition - 1
                  : caretPosition
                : caretPosition - 1
              : caretPosition
            : caretPosition +
              (!isChange || lastIndex != 0 ? (pointerNearEmpty ? 1 : 0) : 1);

          this.firstLoadItem = false;
          this.isActionScheduled = false;
          // if(this.checkIsPaste){
          //   this.checkIsPaste = false;
          // }
        }
      });
      this.oldPhone = JSON.parse(JSON.stringify(this.phoneNumber));
      // if (!isValid){
      //   this.checkIsdn = true;
      //
      //   return;
      // }else{
      //   this.checkIsdn = false;
      // }

      let rep = this.formatSpacingPhoneNumber(this.phoneNumber);
      var formatPhoneNumberCheck = this.regexMetfone(rep);
      if (!formatPhoneNumberCheck) {
        this.checkIsdn = true;
        return;
      } else {
        this.checkIsdn = false;
      }

      if (
        this.profile &&
        this.phoneNumber != this.formatPhone(this.profile.phone)
      ) {
        this.isMetfoneNumber = false;
      } else {
        this.isMetfoneNumber = true;
      }
    }, 0),
   
    resetPaymentPayload() {
      this.payment = {
        amount: "0",
        currency: "",
        useDefault: true,
        account: "", // something that unique like transaction_id|invioce_id|ticket_id
        appId: "",
        additionalKey: {
          //autoRenew: false,
          remark: "",
        },
      };
      this.dataGetStatus = null;
    },

    handlerClose() {
      this.$emit("update:isShow", false);
      this.$router.replace("/home");
    },
 
    
    debouncedHandleClick: _.debounce(function () {
      this.handleBuy();
    }, 200),
    
    

    loadFirstPhoneNumber() {
      this.phoneNumber = null;
      this.checkIsdn = false;
      this.isMetfoneNumber = this.phoneNumberIsMetfone;
      if (this.profile && this.profile.phone) {
        let phone = this.profile.phone;
        let tempPhone = phone.replace(/\D/g, "");
        const modifiedNumber = tempPhone.replace(/^855/, "0");
        // this.checkMobileMetfoneNumber = !this.regexMetfone(tempPhone);
        const text = this.formatPhoneNumberTwo(modifiedNumber);
        this.phoneNumber = text;
      }
      // const text = this.formatPhoneNumberTwo("031544520");
      // this.phoneNumber = text;
      this.firstLoadItem = true;
      // if(this.phoneNumberInput){
      //   this.phoneNumberInput.selectionStart = this.phoneNumber.length;
      //   this.phoneNumberInput.selectionEnd =this.phoneNumber.length;
      // }
      //
    },
    getCheckShowModalMetfone() {
      let phone = this.phoneNumber;
      let tempPhone = phone.replace(/\D/g, "");
      this.checkMobileMetfoneNumber = !this.regexMetfone(tempPhone);
      return this.checkMobileMetfoneNumber;
    },
    formatPhone(val) {
      let tempPhone = val.replace(/\D/g, "");
      return tempPhone;
    },
  },
};
</script>

<style lang="scss" scoped>
.card-detail {
  //padding: 0 16px;

  .credit-card-title {
    color: #000;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    /* 128.571% */
    text-transform: uppercase;
    margin-left: 10px;
  }

  .close-line {
    display: flex;
    justify-content: center;
    padding: 16px;

    .close-line-item {
      width: 40px;
      height: 4px;
      border-radius: 4px;
      background: #90a3bf;
    }
  }

  .detail-title {
    color: #101828;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 10px;
    margin: 16px 0px;
  }

  .card-line {
    border-top: 1px dashed #c9c9c9;
  }

  .card-description {
    color: #667085;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;

    div {
      margin: 0 0 3px 0;
    }

    ol {
      list-style: inside;
      padding-left: 8px;

      li {
        color: #667085;
        font-family: SF Pro Text;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        letter-spacing: -0.14px;
        margin: 0 0 3px 0;
      }
    }
  }

  .phone-number {
    margin-bottom: 0px;
    border-radius: 8px;
    border: 1px solid var(--gray-300, #d0d5dd);
    background: var(--white, #fff);
    /* Shadow/xs */
    box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .input-phone-number {
      width: 100%;
      border: none;
    }

    .van-cell.van-field {
      padding: 0px;
    }
  }

  .btn-bottom {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .btn-buy {
      display: flex;
      padding: 13px 0px;
      height: 48px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      //flex: 1 0 0;
      width: 100%;
      border-radius: 8px;
      background: #ef5350;
      flex-shrink: 0;

      /* Shadow/xs */
      box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
      //margin: 16px 0;
      margin-top: 0px;

      .btn-buy-content {
        color: var(--White, #fff);
        text-align: center;
        font-size: 16px;
        font-family: Inter;
        font-style: normal;
        font-weight: 600;
        line-height: 22px;
        /* 137.5% */
        letter-spacing: -0.066px;
        margin-bottom: 0;
      }
    }

    .btn-auto-renew {
      display: flex;
      justify-content: start;
      align-items: start;
      gap: 12px;
      width: 100%;
    }

    .btn-auto-renew-title {
      color: #272d37;
      font-family: SF Pro Text;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
    }

    .btn-auto-renew-description {
      color: #8e9196;
      font-family: SF Pro Text;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%;
    }
  }

  .input-errors {
    font-size: 12px;
    color: orangered;
    margin-top: 4px;
  }

  .phone-number-title {
    color: #272d37;
    font-feature-settings:
      "clig" off,
      "liga" off;
    font-family: SF Pro Text;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.14px;
    margin-bottom: 6px;
  }

  .metfone-tooltip {
    padding: 6px 8px;
    align-items: center;

    p {
      color: var(--f, #fff);
      font-family: Roboto;
      font-size: 10px;
      font-style: normal;
      font-weight: 400;
      line-height: 162.687%;
      /* 16.269px */
      letter-spacing: -0.181px;
    }
  }

  .icon-aba-pay {
    display: flex;
    justify-content: start;
    align-items: center;
  }

  .credit-card-image {
    background-color: #005d85;
    image-rendering: pixelated;
    height: 18px;
    width: 30px;
    border-radius: 5px;
  }

  .credit-card-title {
    color: #000;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    /* 128.571% */
    text-transform: uppercase;
    width: 71px;
  }

  .saving-account {
    color: #000;
    font-family: Inter;
    font-style: normal;
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    /* 137.5% */
    letter-spacing: -0.066px;
  }

  .credit-card-phone {
    //color: #000;
    //font-size: 12px;
    //font-style: normal;
    //font-weight: 500;
    //line-height: normal;
    opacity: 0.5;
    color: #000;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .saving-change {
    //color: #EF5350;
    //text-align: right;
    //font-size: 13px;
    //font-style: normal;
    //font-weight: 600;
    //line-height: 22px;
    /* 137.5% */
    //letter-spacing: -0.066px;

    display: flex;
    justify-content: center;

    color: #ef5350;
    text-align: right;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    /* 137.5% */
  }

  .credit-card {
    //margin-top: 16px;
  }
}

.aba-pay {
  margin-top: 16px;
}

.content-apa-pay {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: start;
  line-height: 1.4rem;
}

.title-apa-pay {
  font-size: 17px;
  font-weight: bold;
  margin: 0;
  margin-bottom: 4px;
}

.sub-title-apa-pay {
  margin: 0;
  opacity: 50%;
  size: 12px;
}

.change-apa-pay {
  color: #ef5350;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
}

.saving-change-icon {
  display: flex;
  justify-content: start;
  text-align: start;
  justify-items: start;
}

.savingname-container {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: initial;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  padding-right: 5px;
}

.disabled {
  pointer-events: none;
  /* Disables all pointer events */
  opacity: 0.5;
  /* Visually indicate the element is disabled */
}

.btn-contact {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 5px;
}
</style>
